<ng-container *ngIf="certificate.typeCertificate == 3; else notOTP">
  <h2 mat-dialog-title mat-dialog-draggable-special> {{'title.info_digital_certificate_otp' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
</ng-container>
<ng-template #notOTP>
  <h2 *ngIf="isSync" mat-dialog-title mat-dialog-draggable-special> {{'title.sync_digital_certificate' | translate}}
    {{certificate.issuedTo}}
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <h2 *ngIf="!isSync" mat-dialog-title mat-dialog-draggable-special> {{'title.edit_digital_certificate' | translate}}
    {{certificate.issuedTo}}
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
</ng-template>
<mat-divider></mat-divider>
<mat-dialog-content #focus tabindex="-1">
  <form *ngIf="certificate" name="form" #f="ngForm" appFocusFirstElement>
    <ng-container *ngIf="certificate.typeCertificate == 3; else notOTP">
      <div class="row mt-3">
        <div class="col-12">
          <mat-label>
            <small>{{'digital_certificate_management.lbl_phone' | translate}}</small>
            <p class="dotted">{{ certificate.phoneNumber }}</p>
          </mat-label>
        </div>
      </div>
    </ng-container>
    <ng-template #notOTP>
      <div class="row mt-3">
        <!-- Tên doanh nghiệp -->
        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.enterpriseName" name="certificate.enterpriseName"
                   [placeholder]="'digital_certificate_management.lbl_enterprise' | translate" [readonly]="true">
          </mat-form-field>
        </div>
        <!-- Loại chứng thư -->
        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.typeCertificateInText" name="certificate.typeCertificateInText"
                   [placeholder]="'digital_certificate_management.cbx_certificate_type.lbl_certificate_type' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        <!-- Tên chủ thể -->
        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.issuedTo" name="certificate.issuedTo"
                   [placeholder]="'enterprise-certificate_management.table_headers.issued_to' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.issuedBy" name="certificate.issueBy"
                   [placeholder]="'digital_certificate_management.certification_organization' | translate"
                   readonly="true">
          </mat-form-field>
        </div>
        

        <div class="col-6">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.taxCode" name="certificate.taxCode"
                   [placeholder]="'digital_certificate_management.tax_code' | translate" [readonly]="true">
          </mat-form-field>
        </div>
        <div class="col-6" *ngIf="certificate.activeDateNew">
          <mat-form-field class="mat-form-field-disabled mat-form-field-date-prefix">
            <span class="d-flex" matPrefix> <span class="text-decoration-line-through">{{certificate.activeDate | dateformat}}</span> &nbsp;<mat-icon>arrow_right</mat-icon>&nbsp;</span>
            <input class="text-primary" matInput [ngModel]="certificate.activeDateNew | dateformat" name="certificate.activeDate"
                   [placeholder]="'enterprise-certificate_management.table_headers.effective_date' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        <div class="col-6" *ngIf="!certificate.activeDateNew">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.activeDate | dateformat" name="certificate.activeDate"
                   [placeholder]="'enterprise-certificate_management.table_headers.effective_date' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        <div class="col-6" *ngIf="certificate.cloudCaUsername && isSync">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.cloudCaUsername" name="certificate.cloudCaUsername"
                   [placeholder]="'enterprise-certificate_management.table_headers.cloud_ca_username' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        <div class="col-6" *ngIf="certificate.expireDateNew">
          <mat-form-field class="mat-form-field-disabled mat-form-field-date-prefix">
            <span class="d-flex" matPrefix> <span class="text-decoration-line-through">{{certificate.expireDate | dateformat}}</span> &nbsp;<mat-icon>arrow_right</mat-icon>&nbsp;</span>
            <input class="text-primary" matInput [ngModel]="certificate.expireDateNew | dateformat" name="certificate.expireDate"
                   [placeholder]="'enterprise-certificate_management.table_headers.expiry_date' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        <div class="col-6" *ngIf="!certificate.expireDateNew">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.expireDate | dateformat" name="certificate.expireDate"
                   [placeholder]="'enterprise-certificate_management.table_headers.expiry_date' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>
        <div class="col-12" *ngIf="certificate.serialNumberNew">
          <mat-form-field class="mat-form-field-disabled mat-form-field-date-prefix" floatLabel="always">
            <mat-label style="margin-left: 17.5%;"> {{'form.serial_number' | translate}}</mat-label>
            <span class="d-flex" matPrefix> <span class="text-decoration-line-through">{{certificate.serialNumber}}</span> &nbsp;<mat-icon>arrow_right</mat-icon>&nbsp;</span>
            <input class="text-primary" matInput [ngModel]="certificate.serialNumberNew" name="certificate.serialNumber">
          </mat-form-field>
        </div>
        <div class="col-6" *ngIf="!certificate.serialNumberNew">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.serialNumber" name="certificate.serialNumber"
                   [placeholder]="'form.serial_number' | translate" [readonly]="true">
          </mat-form-field>
        </div>
        <!-- <div class="col-6 mb-2">
          <form class="example-form">
            <mat-form-field class="example-full-width" appearance="fill">
              <mat-label>Nhập username/fullname</mat-label>
              <input type="text"
                     placeholder="Nhập tên người dùng/username"
                     aria-label="Number"
                     matInput
                     [formControl]="userName"
                     [matAutocomplete]="auto">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="getIdFilterOption.bind(this)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option.id" (onSelectionChange)="selectUser(option) " >
                  {{option.name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </form>
        </div>  -->
        <!-- Tên file -->
        <div class="col-6" *ngIf="certificate.filePath">
          <mat-form-field class="mat-form-field-disabled">
            <input matInput [ngModel]="certificate.filePath" name="certificate.filePath"
                   [placeholder]="'enterprise-certificate_management.table_headers.file_path' | translate"
                   [readonly]="true">
          </mat-form-field>
        </div>

      </div>

<!--      <mat-table [dataSource]="valueTable">-->

<!--        &lt;!&ndash; Số thứ tự &ndash;&gt;-->
<!--        <ng-container matColumnDef="stt">-->
<!--          <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">-->
<!--            {{'enterprise_contract.table_headers.No' | translate}}-->
<!--          </mat-header-cell>-->
<!--          <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">-->
<!--            {{element.id}}-->
<!--          </mat-cell>-->
<!--        </ng-container>-->

<!--        &lt;!&ndash; Phương thức ký &ndash;&gt;-->
<!--        <ng-container matColumnDef="userNameManager">-->
<!--          <mat-header-cell *matHeaderCellDef-->
<!--                           class="mat-header-cell-center mat-cell-non-boder-right-bottom">-->
<!--            {{'enterprise-certificate_management.table_headers.digital_certificate_type' | translate}}-->
<!--          </mat-header-cell>-->
<!--          <mat-cell *matCellDef="let element" class="text-center mat-cell-non-boder-right-bottom">-->
<!--            {{element.name}}-->
<!--          </mat-cell>-->
<!--        </ng-container>-->

<!--        &lt;!&ndash; Tác động Column &ndash;&gt;-->
<!--        <ng-container matColumnDef="action" class="mat-column-symbol mat-cell-non-boder-bottom">-->
<!--          <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col mat-cell-non-boder-bottom"-->
<!--                           style="max-width: 15%;">-->
<!--            {{'headertable.action' | translate}}-->
<!--          </mat-header-cell>-->
<!--          <mat-cell *matCellDef="let element" class="mat-header-cell-center action-col"-->
<!--                    style="max-width: 15%;">-->
<!--            <button>123</button>-->
<!--          </mat-cell>-->
<!--        </ng-container>-->

<!--        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>-->
<!--        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row">-->
<!--        </mat-row>-->
<!--      </mat-table>-->
    </ng-template>

    <div class="row mt-3">
      <!--    upload anh-->
      <div class="col-6 pr-075">
        <div nz-upload-btn class="ant-upload mb-2">
          <div class="upload-note d-flex pb-2">
            <span style="margin-bottom: 0.5em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">{{'title.upload_image_sign' | translate}}</span>
            <small class="ml-1 mr-2"><i style="font-size: 0.8rem;">({{'title.upload_image_sign_guiding6' | translate}})</i></small>
            <mat-icon matSuffix
                      matTooltip="{{'title.upload_image_sign_guiding5' | translate}}"
                      class="custom-position-for-icon">help_outline
            </mat-icon>
          </div>
          <div class="clearfix nz-upload-clearfix">
            <div class="col-12 pr-075 pl-0 mb-2">
              <div class="wrap-upload">
                <div>
                  <nz-upload style="max-width: 100% !important;padding:1rem 1rem 0 1rem"
                    [nzAccept]="'image/jpeg,image/jpg,image/png'"
                    [nzPreview]="handlePreview"
                    class="avatar-uploader"
                    [nzCustomRequest]="dummyRequest"
                    nzName="avatar"
                    nzListType="picture-card"
                    [nzShowUploadList]="false"
                    [nzBeforeUpload]="beforeUpload"
                    (nzChange)="handleChange($event)">
                    <ng-container *ngIf="!avatarUrl">
                      <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
                      <div class="ant-upload-text">Upload</div>
                    </ng-container>
                    <img *ngIf="avatarUrl" [src]="sanitize(avatarUrl)" style="width: 100%"/>
                  </nz-upload>
                </div>
                  <div *ngIf="avatarUrl!=null&&avatarUrl!=''"  style="text-align:right; padding-right: 1rem;">
                  <i (click)="confirmDelete()" class="fa fa-trash mb-2"
                     aria-hidden="true" matTooltip="{{'tooltips.delete' | translate}}"></i>
                  </div>
              </div>
              <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContent" [nzFooter]="null"
                        (nzOnCancel)="previewVisible = false">
                <ng-template #modalContent>
                  <img [src]="sanitize(avatarUrl)" [ngStyle]="{ width: '100%' }"/>
                </ng-template>
              </nz-modal>
    <!--          <span class="nz-upload-guiding">{{'title.upload_image_sign_guiding1' | translate}}<br/>{{'title.upload_image_sign_guiding2' | translate}}</span>-->
            </div>
          </div>
          <mat-error *ngIf="wrongFileFormat">
            {{'messages.only_accept_png_jpg' | translate}}
          </mat-error>
          <mat-error *ngIf="fileTooLarge">
            {{'messages.image_must_than_2m' | translate}}
          </mat-error>
        </div>
      </div>
      <!--    list nguoi quan ly-->
      <div class="col-6 pr-075">
        <mat-panel-title class="mat-panel-title border-0 m-0 p-0">
          <span class="ant-upload pb-2" style="margin-bottom: 0.5em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">{{'enterprise-certificate_management.table_headers.user_management' | translate}}</span>
        </mat-panel-title>
        <div>
          <nz-input-group [nzSuffix]="suffixUserInput">
            <input nz-input [(ngModel)]="inputUserValue"
                   (input)="onChangeUserSignSearch($event)" [nzAutocomplete]="autoUserSearching"
                   [ngModelOptions]="{ standalone: true }"
                   placeholder="{{'placeholder.name_and_email' | translate}}" id="inputUser"/>
            <nz-autocomplete #autoUserSearching>
              <nz-auto-option *ngFor="let user of filteredUserOptions"
                              (selectionChange)="autocompleteUserSelected($event, user)"
                              [nzValue]="''">{{user.name}}</nz-auto-option>
            </nz-autocomplete>
          </nz-input-group>
          <ng-template #suffixUserInput>
            <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
          </ng-template>
          <ng-template #indicatorUserInput>
            <i class="nz-icon-font" nz-icon nzType="loading" style="font-size: 24px;"></i>
          </ng-template>
        </div>
        <nz-table nzBordered [nzNoResult]="null" [nzData]="certificate.lstIdNameDTO" nzShowPagination=false
                  class="mt-2 ant-table-no-border border-top-0" [ngClass]="{'is-data': certificate && certificate.lstIdNameDTO && certificate.lstIdNameDTO.length > 0}">
          <tbody>
          <tr *ngFor="let username of certificate.lstIdNameDTO" class="editable-row">
            <td>{{username.name}}</td>
            <td class="text-center">
              <a class="text-center" nz-popconfirm nzPopconfirmTitle="{{'popup.confirm_delete_user' | translate}}"
                 (nzOnConfirm)="deleteCertificate(username)" [nzIcon]="iconDel"
                 nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                <i class="fa fa-trash" aria-hidden="true" matTooltip="{{'tooltips.delete' | translate}}"></i>
              </a>
              <ng-template #iconDel>
                <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
              </ng-template>
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-divider></mat-divider>


<div class="mb-2 mt-2" *ngIf="certificate.activeDateNew || certificate.expireDateNew">
  <span class="text-primary note-cert mb-2"> {{'certificate.note' | translate}}</span>
</div>
<mat-dialog-actions align="center" class="mt-2">
  <button mat-stroked-button color="primary" (click)="onCancel()" class="mr-3" type="button">
    <mat-icon class="mr-0">cancel</mat-icon>
   
    <span *ngIf="!isSync"> {{'view_pdf.buttons.close' | translate}}</span>
    <span *ngIf="isSync">{{'button.cancel' | translate}}</span>
  </button>
  <button mat-raised-button color="primary" [disabled]="!isFormChanging && !isSync" (click)="onUpdateCertificateImage()"
          class="mr-3" type="button">
    <mat-icon class="mr-0">save</mat-icon>
    <span *ngIf="!isSync">{{'button.save' | translate}}</span>
    <span *ngIf="isSync">{{'button.synchronized' | translate}}</span>
  </button>
</mat-dialog-actions>
